enum PaymentGatewayIdEnum {
    BRAINTREE = "BRAINTREE",
    FREE = "FREE",
}

export default PaymentGatewayIdEnum;
